import model from '../../model/index'

const types = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  ADD_ITEM: 'ADD_ITEM'
}

const state = {
  sidebarOpen: false,
  sidebarItems: []
}

const getters = {
  sidebarOpen: state => state.sidebarOpen
}

const actions = {
  toggleSidebar ({ commit, state }) {
    console.log('sidebar opened')
    commit(types.TOGGLE_SIDEBAR)
  },
  async fetchSidebarItems () {
    state.sidebarItems = model.getSidebarComponents()
  }
}

// mutations
const mutations = {
  [types.TOGGLE_SIDEBAR] (state) {
    state.sidebarOpen = !state.sidebarOpen
  },
  [types.ADD_ITEM] (state, item) {
    state.sidebarItems.push(item)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebars.js